module.exports = __webpack_public_path__ + "img/Villa_Borna_60.2d4cf0a5.jpg";